import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
export class WizardStepStylingModel extends CoreStylingModel {
/**
 * Styling by type StylingModel
 */
label?: StylingModel;
/**
 * Styling by type StylingModel
 */
iconIndex?: StylingModel;
/**
 * Styling by type StylingModel
 */
prefixIndex?: StylingModel;
/**
 * It is the constructor for the WizardStepStylingModel. It takes the values to create the WizardStepStylingModel object.
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function WizardStepStylingModel_tsickle_Closure_declarations() {
/**
 * Styling by type StylingModel
 * @type {?}
 */
WizardStepStylingModel.prototype.label;
/**
 * Styling by type StylingModel
 * @type {?}
 */
WizardStepStylingModel.prototype.iconIndex;
/**
 * Styling by type StylingModel
 * @type {?}
 */
WizardStepStylingModel.prototype.prefixIndex;
}

